module.exports = __webpack_public_path__ + "img/7.f0f4ff84.jpg";